import { SelectOption } from '@diamond/shared/types';
import { reactSelectStyles } from '@diamond/shared/ui';
import { ChakraStylesConfig as StylesConfig } from 'chakra-react-select';

export const multiSelectStyles: StylesConfig<SelectOption, true> = {
  ...(reactSelectStyles as unknown as StylesConfig<SelectOption, true>),
  container(base) {
    return {
      ...base,
      minWidth: 300,
      flex: 1,
    };
  },
};
